// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contract-header {
  cursor: pointer;
}

.contract-header:hover {
  background: #fafafb;
}

.contract-details-link:hover {
  border-color: #b6b6c2 !important;
}

/* Shared utility classes used by other pages that happen to bundle this
   stylesheet — kept as-is, out of scope for the Contracts-block rewrite. */
.cursor-pointer {
  cursor: pointer;
}

.card-header {
  background: #f8f9fa !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Client/css/ClientContracts.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;2EAC2E;AAC3E;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".contract-header {\n  cursor: pointer;\n}\n\n.contract-header:hover {\n  background: #fafafb;\n}\n\n.contract-details-link:hover {\n  border-color: #b6b6c2 !important;\n}\n\n/* Shared utility classes used by other pages that happen to bundle this\n   stylesheet — kept as-is, out of scope for the Contracts-block rewrite. */\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.card-header {\n  background: #f8f9fa !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
